import React, { createContext, useContext, useState, useEffect } from 'react';
import { calculatePlatformFee } from '../utils/api/platformFee';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem('hobi_cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('hobi_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems((prevItems) => {
      // Check if item already exists (same event and same ticket)
      const existingItemIndex = prevItems.findIndex(
        (i) => i.eventId === item.eventId && i.ticketId === item.ticketId && (i.targetMonth || null) === (item.targetMonth || null)
      );

      if (existingItemIndex > -1) {
        const newItems = [...prevItems];
        newItems[existingItemIndex].ticketsCount += item.ticketsCount;
        return newItems;
      } else {
        return [...prevItems, item];
      }
    });
  };

  const removeFromCart = (eventId, ticketId, targetMonth = null) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => !(item.eventId === eventId && item.ticketId === ticketId && (item.targetMonth || null) === targetMonth))
    );
  };

  const updateCartItemQuantity = (eventId, ticketId, count, targetMonth = null) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.eventId === eventId && item.ticketId === ticketId && (item.targetMonth || null) === targetMonth
          ? { ...item, ticketsCount: count }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => {
      return total + ((item.ticketPrice * item.ticketsCount) + calculatePlatformFee(item.ticketPrice * item.ticketsCount));
    }, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateCartItemQuantity,
        clearCart,
        getCartTotal,
        isCartOpen,
        setIsCartOpen,
        toggleCart: () => setIsCartOpen(!isCartOpen)
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
